import { graphql } from 'src/graphql';

export const FetchProjectUsers = graphql(`
  query FetchProjectUsers($id: ID) {
    projectByID(id: $id) {
      users {
        _id
        status
        User {
          _id
          email
          meta {
            identity {
              firstname
              lastname
            }
          }
          contact {
            phone {
              mobile
            }
          }
        }
      }
    }
  }
`);
